export const DATE_RANGE_OPTIONS = ['전체', '최근 7일', '이번 달', '사용자 지정'];